import React from 'react';
import PropTypes from 'prop-types';
import { getTokensPropType, selectSystemProps, useThemeTokens, useViewport, variantProp } from '@telus-uds/components-base';
import styled from 'styled-components';
import { htmlAttrs } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
const [selectProps, selectedSystemPropTypes] = selectSystemProps([htmlAttrs]);
const CardContentContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "CardContent__CardContentContainer",
  componentId: "components-web__sc-1k2501q-0"
})(_ref => {
  let {
    borderRadius,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    withFooter,
    contentAlignItems: alignItems,
    contentFlexGrow: flexGrow,
    contentFlexShrink: flexShrink,
    contentJustifyContent: justifyContent,
    borderWidth
  } = _ref;
  return {
    // We need to make sure to have sharp corners on the bottom
    // if the card has a footer
    borderBottomLeftRadius: withFooter ? 0 : borderRadius,
    borderBottomRightRadius: withFooter ? 0 : borderRadius,
    borderTopLeftRadius: borderRadius,
    borderTopRightRadius: borderRadius,
    paddingBottom: paddingBottom - borderWidth,
    paddingLeft: paddingLeft - borderWidth,
    paddingRight: paddingRight - borderWidth,
    paddingTop: paddingTop - borderWidth,
    display: 'flex',
    flexDirection: 'column',
    alignItems,
    flexGrow,
    flexShrink,
    justifyContent
  };
});

/**
 * Card content, applying the card tokens as per the theme used.
 */
const CardContent = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    children,
    flexContent,
    tokens,
    variant,
    withFooter = false,
    ...rest
  } = _ref2;
  const viewport = useViewport();
  const themeTokens = useThemeTokens('Card', tokens, variant, {
    viewport
  });
  return /*#__PURE__*/_jsx(CardContentContainer, {
    ...themeTokens,
    flexContent: flexContent,
    withFooter: withFooter,
    ref: ref,
    ...selectProps(rest),
    children: children
  });
});
CardContent.displayName = 'CardContent';
CardContent.propTypes = {
  ...selectedSystemPropTypes,
  /**
   * Card section content.
   */
  children: PropTypes.node,
  /**
   * Card tokens.
   */
  tokens: getTokensPropType('Card'),
  /**
   * Card variant.
   */
  variant: variantProp.propType,
  /**
   * Whether the card has a footer.
   */
  withFooter: PropTypes.bool
};
export default CardContent;